import React from "react"

const ScrollingContext = React.createContext({isScrolling: false, setIsScrolling: ()=>{}})

export default ScrollingContext